<script>
export default {
  name: "ThresholdInputForm",
  props: {
    label: { type: String, default: () => "" },
    dataKey: { type: String, default: () => "a" },
    upper: { type: Number, default: () => 0 },
    lower: { type: Number, default: () => 0 },
  },
  methods: {
    input(key, value) {
      if (!isNaN(+value)) {
        this.$emit("update", { [`${this.dataKey}_${key}`]: +value });
      }
    },
  },
};
</script>

<template>
  <v-row>
    <v-col cols="12">
      <header>{{ label }}</header>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        class="input-form__upper"
        label="上限値"
        :value="upper"
        @input="input('upper', $event)"
        required
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        class="input-form__lower"
        label="下限値"
        :value="lower"
        @input="input('lower', $event)"
        required
        dense
      ></v-text-field>
    </v-col>
  </v-row>
</template>
